import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import NavBarProfil from "../../components/NavBarProfil/NavBarProfil";
import CardCommande from "../../components/CardCommande/CardCommande";
import AccountActiveOrNot from "../../components/AccountActiveOrNot/AccountActiveOrNot";
import TextAccountNotActiveWithDeconnectButton
    from "../../components/AccountActiveOrNot/TextAccountNotActiveWithDeconnectButton";
import "./Commandes.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";

function Commandes() {
    const location = useLocation();
    const {commandes} = location.state || {};
    const [accountActive, setAccountActive] = useState(null);

    const tableauObjet = Object.values(commandes || {});

    // Trier les commandes par date la plus récente
    tableauObjet.sort((a, b) => new Date(b.date) - new Date(a.date));

    useEffect(() => {
        document.title = "Mes commandes";
    }, []);

    return (
        <>
            <AccountActiveOrNot setAccountActive={setAccountActive}/>
            {accountActive === false && accountActive !== null ? (
                <TextAccountNotActiveWithDeconnectButton/>
            ) : (
                <div className="div-main-profil">
                    <NavBarProfil></NavBarProfil>
                    <div className={"div-commandes"}>
                        <div className="client-orders-header">
                            <h1>Mes Commandes</h1>
                            <p>Retrouvez ici l'historique et le suivi de vos achats.</p>
                        </div>
                        {tableauObjet.length > 0 ? (
                            <div className="client-orders-list">
                                {tableauObjet.map((commande) => (
                                    <CardCommande
                                        key={commande.idCommande}
                                        idCommande={commande.idCommande}
                                        date={commande.date}
                                        prixTotal={commande.prixTotal}
                                        contenuCommande={commande.contenuCommande}
                                        status={commande.status}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="empty-orders">
                                <FontAwesomeIcon icon={faBoxOpen} style={{ fontSize: "4rem", color: "#cbd5e1", marginBottom: "1rem" }} />
                                <h3>Aucune commande pour le moment</h3>
                                <p>Vous n'avez pas encore passé de commande sur notre boutique.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default Commandes;
